import { InjectionToken } from '@angular/core';

export const ApiUrl = new InjectionToken<string>('api');
